import dayjs from "dayjs";
import durationPlugin from "dayjs/plugin/duration";
import relativeTimePlugin from "dayjs/plugin/relativeTime";
import timezonePlugin from "dayjs/plugin/timezone";
import updateLocalePlugin from "dayjs/plugin/updateLocale";
import utcPlugin from "dayjs/plugin/utc";

dayjs.extend(relativeTimePlugin);
dayjs.extend(durationPlugin);
dayjs.extend(utcPlugin);
dayjs.extend(timezonePlugin);
dayjs.extend(updateLocalePlugin);

dayjs.updateLocale("en", {
  relativeTime: {
    future: "%s from now",
    past: "%s ago",
    s: "a few seconds",
    m: "a minute",
    mm: "%d minutes",
    h: "1 hour",
    hh: "%d hours",
    d: "a day",
    dd: "%d days",
    M: "a month",
    MM: "%d months",
    y: "a year",
    yy: "%d years",
  },
});

export const edt = (str?: string) => {
  return dayjs.tz(str, "America/New_York").toISOString();
};

export const utc = (str?: string) => {
  return dayjs.utc(str).toISOString();
};

export const format = (timestamp: Date) => {
  return dayjs(timestamp).format("DD MMM YYYY");
};

export const year = (timestamp: Date) => {
  return dayjs(timestamp).format("YYYY");
};

// export const smolFormat = (timestamp: Date) => {
//   return dayjs(timestamp).format("D MMM");
// };

export const fromNow = (timestamp: Date) => {
  return dayjs(timestamp).fromNow();
};

export const duration = (str: string) => {
  return dayjs.duration(str).format("H:mm:ss");
};

export const isNew = (timestamp: Date) => {
  const fiveDaysAgo = dayjs.utc().subtract(5, "days");
  return dayjs(timestamp).isAfter(fiveDaysAgo);
};

export const isBefore = (timestamp: Date, quantity: number, unit: dayjs.ManipulateType) => {
  return dayjs(timestamp).isBefore(dayjs.utc().subtract(quantity, unit));
};

export const msFromEpoch = (dateString?: string) => {
  if (!dateString) return Number.NEGATIVE_INFINITY;
  // Parse the date string into a Date object
  const parsedDate = new Date(dateString);
  // Ensure that the parsed date is valid
  return Number.isNaN(parsedDate.getTime()) ? Number.NEGATIVE_INFINITY : parsedDate.getTime();
};
